import { getCommodityClasses,getCommodityProps,addCommodity,addImage } from '@/api/commodity'
import * as types from '../mutaion-types'

const commodity = {
	state:{
		
	},
	mutations:{
		
	},
	actions:{
		getCommodityClasses({ commit }){
	    	return new Promise(async (resolve, reject) => {
		        try {
		          const response = await getCommodityClasses()
		          resolve(response)
		        } catch (error) {
		          reject(error)
		        }
		    })
	    },
	    getCommodityProps({ commit },{cid}){
	    	return new Promise(async (resolve, reject) => {
		        try {
		          const response = await getCommodityProps(cid)
		          resolve(response)
		        } catch (error) {
		          reject(error)
		        }
		    })
	    },
	    addCommodity({ commit },{cid,name,mainImage,customerProps,saleProps,binds,skuList}){
	    	return new Promise(async (resolve, reject) => {
		        try {
		          const response = await addCommodity(cid,name,mainImage,customerProps,saleProps,binds,skuList)
		          resolve(response)
		        } catch (error) {
		          reject(error)
		        }
		    })
	    }
	}
}

export default commodity